"use client";
import { ChangeEvent } from "react";

import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";

interface DocumentSearchProps {
	searchQuery: string;
	showClearIcon: boolean;
	onSearchChange: (e: ChangeEvent<HTMLInputElement>) => void;
	onClearSearch: () => void;
}

const DocumentSearch = ({
	searchQuery,
	showClearIcon,
	onSearchChange,
	onClearSearch,
}: DocumentSearchProps) => {
	return (
		<TextField
			placeholder="Tìm kiếm"
			size="small"
			variant="outlined"
			value={searchQuery}
			onChange={onSearchChange}
			fullWidth
			InputProps={{
				startAdornment: (
					<InputAdornment position="start">
						<SearchIcon />
					</InputAdornment>
				),
				endAdornment: showClearIcon && (
					<InputAdornment position="end">
						<CloseIcon onClick={onClearSearch} style={{ cursor: "pointer" }} />
					</InputAdornment>
				),
			}}
		/>
	);
};

export default DocumentSearch;
